export enum TheftMarkerTypes {
  None = 0,
  SecurityWatch = 1,
  Vrm = 2,
  StolenOrVin = 3
}
